export const menuData = {
  poissons: [
    { name: "Tartare de thon à la tahitienne", description: "Thon frais mariné aux saveurs locales", price: "2 800" },
    { name: "Tartare de thon au curry", description: "Thon frais, curry doux et lait de coco", price: "2 900" },
    { name: "Poisson cru au lait de coco", description: "Le classique polynésien revisité", price: "2 700" },
    { name: "Mahi mahi crème rhum-vanille", description: "Servi avec riz à l'ail", price: "3 600" },
    { name: "Mahi mahi risotto", description: "Risotto crémeux aux herbes fraîches", price: "3 700" },
    { name: "Shrimp Special", description: "Crevettes flambées au rhum avec riz", price: "3 600" },
    { name: "Moules au vin blanc", description: "Accompagnées de frites croustillantes", price: "3 200" },
    { name: "Tempura de crevettes", description: "Légèrement panées, sauce maison", price: "3 400" }
  ],
  viandes: [
    { name: "Magret de canard sauce miel", description: "Tendre et savoureux, servi avec frites", price: "4 200" },
    { name: "Flank steak grillé", description: "Bavette aux oignons confits et sauce au miel", price: "3 400" },
    { name: "Beef stew", description: "Ragoût de bœuf mijoté aux légumes", price: "3 300" },
    { name: "Porc croustillant miel-ananas", description: "Croustillant et sucré-salé, riz à l'ail", price: "3 600" },
    { name: "Souris d'agneau sauce miel", description: "Fondante, gratin de pommes de terre", price: "4 200" },
    { name: "Tartare de bœuf + rillettes", description: "Toast de rillettes de canard, frites", price: "2 900" }
  ],
  signature: [
    { name: "Feuilleté d'escargots", description: "Pâte feuilletée croustillante, beurre persillé", price: "3 800" },
    { name: "Pear ravioli", description: "Raviolis à la poire, sauce crémeuse unique", price: "3 500" }
  ],
  desserts: [
    { name: "Molten chocolate lava cake", description: "Coulant au chocolat chaud, glace vanille", price: "1 200" },
    { name: "Tiramisu maison", description: "Recette traditionnelle, café et mascarpone", price: "1 100" },
    { name: "Tarte citron meringuée", description: "Acidulée et légère", price: "1 100" },
    { name: "Crème brûlée", description: "Classique français, caramélisée à la perfection", price: "1 000" }
  ]
};